/* eslint-disable */
export default {
  noRecords: 'Nenhum registro recente encontrado.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
